// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"640":"782765d2","2419":"782765d2","3887":"782765d2","4382":"782765d2","8655":"782765d2","8690":"292ae22a"}[chunkId] + ".chunk.css";
};